<template>
  <div id="step-waiver-signature">
    <v-card :loading="loadingSignatures">
      <v-card-title class="text-h5 grey lighten-2">
        {{ vCardTitle }}
      </v-card-title>

      <v-card-text>
        
        <v-radio-group v-model="signatureUUID" v-if="!isAddingNewSignature && !loadingSignatures">
          <v-row v-for="(signature, index) in signatures" :key="signature.id || signature.signatureUUID || index" class="align-center">
            <v-col md="1" sm="1" cols="12" class="text-left">
              <v-radio :value="signature.signatureUUID" @click="selectSignature(signature)"></v-radio>
            </v-col>
            <v-col md="10" sm="10" cols="12" class="text-left">
              <v-img max-height="200" max-width="700" :src="getSignatureImage(signature)" @click="selectSignature(signature)"></v-img>
            </v-col>
            <v-col md="1" sm="1" cols="12" class="text-left">
              <v-icon small @click="deleteSign(signature)">fas fa-trash-alt</v-icon>
            </v-col>
          </v-row>
        </v-radio-group>

        <v-btn
          color="primary"
          class="ma-2 white--text"
          left
          @click="openDrawer"
          v-if="!isAddingNewSignature"
        >        
          <v-icon left>mdi-plus-box-outline</v-icon>
          <span style="padding-left: 10px;">{{ $t('member_registration.waiver_signature.create_signature') }}</span>
        </v-btn>

        <DrawSignature v-if="isAddingNewSignature" ref="signatures" @getImage="getImage"
          @changeBandSignature="changeBandSignature" :sizeCanvas="dialogSignature" 
        />
          
      </v-card-text>
      <v-card-actions>
        
      </v-card-actions>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="isAddingNewSignature" color="primary" text @click="closeDrawer">
          {{ $t('member_registration.waiver_signature.cancel') }}
        </v-btn>
        <v-btn v-if="!isAddingNewSignature" color="primary" text @click="closeDialog">
          {{ $t('member_registration.waiver_signature.cancel') }}
        </v-btn>
        <v-btn v-if="isAddingNewSignature" color="primary" text @click="saveSignature">
          {{ $t('member_registration.waiver_signature.save_signature') }}
        </v-btn>
        <v-btn v-if="!isAddingNewSignature" color="primary" :disabled="!selectedSignature" text @click="setSignature()">
          {{ $t('member_registration.waiver_signature.accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">{{
          $t("common.sure_delete")
        }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">{{
            $t("common.cancel")
          }}</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="deleteSignature"
            >{{ $t("common.ok") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" timeout="6000" :color="color_snack">{{ msg_snack }}</v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import APIService from "@/services/APIService";
import DrawSignature from "@/components/waiver/DrawSignature_v2";

import {
  VRow,
  VCol,
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCardText,
  VRadio,
  VRadioGroup,
  VImg,
  VDivider,
  VIcon,
  VDialog,
  VSpacer,
  VSnackbar
} from "vuetify/lib";

export default {
  components: {
    VRow,
    VCol,
    VBtn,
    DrawSignature,
    VCard,
    VCardActions,
    VCardTitle,
    VCardText,
    VRadio,
    VRadioGroup,
    VImg,
    VDivider,
    VIcon,
    VDialog,
    VSpacer,
    VSnackbar
  },
  props: {
    waiver: Object,
    signatures: Array,
    urlDomain: String,
    loadingSignatures: Boolean,
    dialog: Boolean,
    defaultSignature: Object,
  },
  data() {
    return {
      waiverStep: 1,
      waivers: [],
      birthdate: "",
      downloadCodes: {
        adults: 1,
        minors: 2,
        everyone: 3,
      },
      signatureUUID: null,
      signatureImage: null,
      signature: null,
      selectedSignature: null,
      disabledSignature: true,
      dialogSignature: false,
      isAddingNewSignature: false,
      signTemp: null,
      dialogDelete: false,
      snack: false,
      msg_snack: '',
      color_snack: 'error',
    };
  },
  watch: {
    signatures(newSignatures) {
      if (!Array.isArray(newSignatures) || newSignatures.length === 0) {
        this.selectedSignature = null;
        this.signatureUUID = null;
        return;
      }

      if (this.selectedSignature && !newSignatures.some((signature) => signature.id === this.selectedSignature.id)) {
        this.selectedSignature = null;
        this.signatureUUID = null;
      }
    }
  },
  computed: {
    ...mapGetters({
      env: "env",
    }),
    prevStep() {
      return 5;
    },
    nextStep() {
      return 6;
    },
    langCode() {
      let code;
      switch (this.$i18n.locale) {
        case "fr":
          code = 2;
          break;

        case "es":
          code = 3;
          break;

        default:
          code = 1;
          break;
      }
      return code;
    },
    signatureUrl() {
      return `${this.env.get("VUE_APP_ROOT")}${this.env.get(
        "VUE_APP_SIGNATURE_PATH"
      )}`;
    },
    vCardTitle(){
      return this.isAddingNewSignature ? this.$t('member_registration.waiver_signature.create_signature') : this.$t('member_registration.waiver_signature.select_signature');
    }
  },
  methods: {
    Initialize(data) {
      this.waivers = data;
      this.setSignature();
    },
    isMinor(date) {
      //TODO: this could be made from laravel
      var today = new Date();
      var bd = new Date(date);
      var edad = today.getFullYear() - bd.getFullYear();
      var m = today.getMonth() - bd.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < bd.getDate())) {
        edad--;
      }
      return edad < 18;
    },
    filteredWaivers(isMinor) {
      return this.waivers.filter(
        (waiver) =>
          (waiver.downloadCode == this.downloadCodes.adults && !isMinor) ||
          (waiver.downloadCode == this.downloadCodes.minors && isMinor) ||
          waiver.downloadCode == this.downloadCodes.everyone
      );
    },
    waiverTranslation(waiver) {
      return waiver.translations.filter(
        (t) => t.fkLanguageCodeId == this.langCode
      )[0];
    },
    
    
    getImage(image) {
      this.signature = image;
    },
    changeBandSignature({ value }) {
      this.disabledSignature = value;
    },
    getSignatureImage(signature) {
      return "data:image/png;base64," + signature.signatureImage;
    },
    setSignature() {
      this.$emit("setSignature", { 
        signatureUUID: this.selectedSignature.signatureUUID,
        signatureImage: this.selectedSignature.signatureImage,
        signatureId: this.selectedSignature.id
      });
      this.closeDialog()
    },
    selectSignature(signature) {
      this.selectedSignature = signature;
      this.signatureUUID = signature.signatureUUID;
    },
    deleteSign(signature){
      this.signTemp = signature;
      this.dialogDelete = true;
    },
    closeDelete(){
      this.signTemp = null;
      this.dialogDelete = false;
    },
    async deleteSignature(){
      const path = `${this.urlDomain}/laravel/public/api/v1/participant/signature/${this.signTemp.id}`;
      const method = 'delete';
      await APIService.fetch({method, path}).then((resp) => {
        if (resp.data.success) {
          this.signTemp = null;
          this.dialogDelete = false;
          this.$emit('getSignatures')
        }
      }).catch(function () { });
    },
    openDrawer() {
      this.signatureUUID = null;
      this.isAddingNewSignature = true;
    },
    resetSignature() {
      this.$refs.signatures.cleanCanvas();
    },
    closeDrawer() {
      this.isAddingNewSignature = false;
      this.resetSignature();
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    showError(message) {
      this.msg_snack = message || this.$t('common.error_general');
      this.color_snack = 'error';
      this.snack = true;
    },
    async saveSignature() {
      const data = {}
      data.base64Img = await this.$refs.signatures.getImage();

      // Guard: getImage() can return undefined/null on an uninitialized canvas.
      // JSON.stringify drops undefined keys, but downstream consumers shouldn't
      // see a missing/non-image base64Img either. See #104.
      if (typeof data.base64Img !== 'string' ||
          !/^data:image\/(png|jpe?g|gif);base64,/.test(data.base64Img)) {
        this.showError(this.$t('common.signature_invalid'));
        return;
      }

      const path = `${this.urlDomain}/laravel/public/api/v1/participant/signatures`;
      const method = 'post';
      await APIService.fetch({method, path, data}).then((resp) => {
        if (resp.data.success) {
          this.$emit('getSignatures')
          this.closeDrawer();
        } else {
          this.showError((resp.data && resp.data.message) || this.$t('common.error_general'));
        }
      }).catch((e) => {
        console.error('Step_WaiverSignature.saveSignature failed', e);
        this.showError(this.$t('common.error_general'));
      });
    },
    getTimeStamp() {
      const now = new Date();
      let month = now.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      let day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();

      return `${now.getFullYear()}-${month}-${day} ${String(
        now.getHours()
      ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
        now.getSeconds()
      ).padStart(2, "0")}`;
    },
  },
};
</script>

<style lang="scss">
  #step-waiver-signature
  {
    .trashSignature
    {
      float: right;
    }
  }
</style>